import React, { useContext } from 'react'
import { AppContext } from 'contexts/AppProvider'
import { useTranslation } from 'react-i18next'
import Icon from 'components/base-ui/Icon'
import CouponItem from 'components/base-ui/CouponItem'
import { Coupon } from 'types/coupon'
import {
  CouponListContainer,
  Header,
  Title,
  RefreshText,
  InfoBox,
  InfoText,
  CouponListSection,
  CouponItemWrapper,
  TitleIcon,
} from './styled'
import CouponListEmpty from './CouponListEmpty'
import CouponListSkeleton from 'components/Skeleton/CouponListSkeleton'

interface CouponListProps {
  coupons: Coupon[]
  loading: boolean
  onRefresh: VoidFunction
  onClickCouponCondition: (serialNumber: string) => void
  onClickRedeem: VoidFunction
  allowedSharingCoupon: boolean
}

const CouponList = ({
  coupons,
  onRefresh,
  loading,
  onClickCouponCondition,
  onClickRedeem,
  allowedSharingCoupon,
}: CouponListProps) => {
  const { brand } = useContext(AppContext)
  const { t } = useTranslation()

  return (
    <CouponListContainer>
      <Header>
        <Title>
          <TitleIcon name="coupon-3" size="16px" />
          {t('dineIn.coupon.fpPrivilegeTitle')}
        </Title>
        <Title onClick={onRefresh}>
          <Icon name="refresh-bold" size="20px" color={brand?.theme.colors.primary} />
          <RefreshText>{t('dineIn.coupon.refresh')}</RefreshText>
        </Title>
      </Header>

      {loading ? (
        <CouponListSkeleton lineAvatar={allowedSharingCoupon} quantity={12} />
      ) : coupons.length > 0 ? (
        <>
          <InfoBox>
            <Icon name="information" size="18px" color="#1562A8" />
            <InfoText>{t('dineIn.coupon.info')}</InfoText>
          </InfoBox>
          <CouponListSection>
            {coupons.map((coupon, index) => (
              <CouponItemWrapper key={index} borderTop={index !== 0}>
                <CouponItem coupon={coupon} onClickCondition={onClickCouponCondition} />
              </CouponItemWrapper>
            ))}
          </CouponListSection>
        </>
      ) : (
        <CouponListEmpty onClickRedeem={onClickRedeem} />
      )}
    </CouponListContainer>
  )
}

export default CouponList
